module.exports = __webpack_public_path__ + "img/fjellskred.a91f4e1c.jpg";